import React, {Component, Fragment} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {minWidthMedia} from "@irati/ui/src/global/media"
import connect from "@irati/store/connect"
import {injectIntl} from "@irati/utils/lang"
import {getSentimentsList} from "@irati-web/insights/src/helpers/Sentiment"
import padding from "@irati/ui/src/global/padding"
import H5 from "@irati/ui/src/Headings/H5"
import getId from "@irati/utils/id"

import Sentiment from "./Sentiment"
import {setSentiment} from "../../../../store/actions/comment"


const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    ${minWidthMedia.tablet`
    padding-right: 18px;
    `}
    > :not(:last-child) {
      margin-right: 10px;
      ${minWidthMedia.tablet`
        margin-right: ${padding.base};
      `}
    }
`

const Title = styled(H5)`
  margin-bottom: ${padding.small}!important;
  ${minWidthMedia.tablet`
    margin-bottom: ${padding.base}!important;
  `}
`

class SentimentList extends Component {
  static propTypes = {
    selectSentiment: PropTypes.func.isRequired,
    selectedSentiment: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired
  }

  handleSubmit = (sentiment) => {
    const {selectSentiment} = this.props
    selectSentiment(sentiment)
  }

  render() {
    const {selectedSentiment, formatMessage} = this.props
    const idNamespace = getId("SentimentList", this.props)
    return (
      <Fragment>
        <Title>{formatMessage({id: "insights.sentiment.title"})}</Title>
        <Wrapper id={idNamespace}>
          {getSentimentsList.map(({id, icon}) => {
            return (
              <Sentiment
                handleClick={this.handleSubmit}
                key={id}
                id={id}
                isActive={id === selectedSentiment}
                icon={icon} />
            )
          })}
        </Wrapper>
      </Fragment>
    )
  }
}

export const mapStateToProps = ({survey}) => ({selectedSentiment: survey.comment.sentiment})

const mapDispatchToProps = (dispatch) => ({
  selectSentiment: (sentiment) => dispatch(setSentiment(sentiment))
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SentimentList))
